var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2362_568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.13745 0.299999H11.7V3.86256H8.13745V0.299999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.57495 4.575H7.42495V7.425H4.57495V4.575Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.57495 8.13756H7.42495V11.7001H4.57495V8.13756Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.300049 4.575H3.86261V7.425H0.300049V4.575Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.300049 8.13756H3.86261V11.7001H0.300049V8.13756Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.300049 0.299999H3.86261V3.86256H0.300049V0.299999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.13745 8.13756H11.7V11.7001H8.13745V8.13756Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.13745 4.575H11.7V7.425H8.13745V4.575Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.57495 0.299999H7.42495V3.86256H4.57495V0.299999Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2362_568"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.c40610c63fccdb69c2ebdd71d821d84c.svg";
export { ForwardRef as ReactComponent };